export class FreespinFeatureEvent {
    public static readonly PATCH_WILD_ON_M:string = "freespinFeatureEvent_patchWildOnM";
    public static readonly SHOW_METER:string = "freespinFeatureEvent_showMeter";
    public static readonly HIDE_METER:string = "freespinFeatureEvent_hideMeter";
    public static readonly METER_SHOWN:string = "freespinFeatureEvent_meterShown";
}